import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20style%20illustration%20with%20abstract%20warm%20color%20gradient%20and%20subtle%20geometric%20patterns%20inspired%20by%20comic%20panels%2C%20soft%20atmospheric%20texture%2C%20dark%20warm%20tones%20with%20coral%20and%20amber%20accents%2C%20dreamy%20mood%2C%20no%20text%2C%20clean%20artistic%20composition&width=1800&height=900&seq=hero-bg-manhwa&orientation=landscape"
          alt="韩漫大全背景"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          {/* Badge */}
          <span className="inline-block px-4 py-1.5 bg-primary-500/20 text-primary-300 rounded-full text-xs font-medium mb-6 border border-primary-500/30 backdrop-blur-sm">
            <i className="ri-sparkling-line mr-1.5"></i>
            韩国漫画资源导航平台
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            发现你的下一部
            <span className="text-primary-400">挚爱韩漫</span>
          </h1>

          <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
            汇集5000+优质韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑等八大分类。
            免费韩漫大全，一键导航，轻松开启你的韩漫在线阅读之旅。
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line mr-2"></i>
              开始探索
            </Link>
            <Link
              to="/article/1"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg backdrop-blur-sm transition-all duration-200 text-sm whitespace-nowrap cursor-pointer border border-white/20"
            >
              <i className="ri-article-line mr-2"></i>
              阅读资讯
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-12">
            {[
              { value: '5000+', label: '收录漫画' },
              { value: '50万+', label: '月活用户' },
              { value: '98%', label: '好评率' },
              { value: '8个', label: '精选分类' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">
                  {stat.value}
                </div>
                <div className="text-white/50 text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/40 text-2xl"></i>
      </div>
    </section>
  );
}